import * as React from 'react'
import { Profile } from 'DVWebNodeUtils'
import { Tooltip } from 'DVWebNodeUI'
import { NavProfiles } from '../transforms/Profiles'

export const ProfilesMenu = (profiles: NavProfiles) => (
<>
    {profiles.otherProfiles.map((profile: Profile, index: number) =>
      <form className="profile-item" id={`profile-${index}`} action={profile.switchLink.partialURL} method="POST">
          <input className="profile-input-submit" type="submit" id={`input-profile-${index}`} name={`input-profile-${index}`} />
          <label htmlFor={`input-profile-${index}`}> 
            <li>
              <div style={{ backgroundImage: `url(${profile.avatarUrl})` }} className="profile-avatar" />
              {profile.name}
            </li> 
          </label>
        {Object.keys(profile.switchLink.query).map((name) => (
          <input type="hidden" name={name} value={profile.switchLink.query[name]}/>
        ))}
      </form>)}
    <a href={profiles.links['preEditProfile']}><li id="manage-profiles"> {profiles.strings['DV_PROFILES_MANAGE']} </li></a>
    <a href={profiles.links['learnMore']}><li> {profiles.strings['DV_PROFILES_LEARNMORE']} </li></a>
  </>
)

const getProfilesTooltipContent = (profiles: NavProfiles) => {
  switch (profiles.tooltipType) {
    case 'INTRO': 
      return (
        <>
          <span className="nav-profiles-tooltip-content nav-profiles-tooltip-heading"> {profiles.strings['DV_PROFILES_INTRO_HEADING']} </span>
          <span className="nav-profiles-tooltip-content nav-profiles-tooltip-text"> {profiles.strings['DV_PROFILES_INTRO_TEXT']} </span>
          <span className="nav-profiles-tooltip-content nav-profiles-tooltip-link"> 
            <a href={profiles.links['learnMore']}> {profiles.strings['DV_PROFILES_INTRO_LINK']} </a> 
          </span>
        </>
      )
      break;
    case 'WELCOME': 
      return (
        <>
          <span className="nav-profiles-tooltip-heading"> {profiles.strings['DV_PROFILES_WELCOME'] || "Welcome back"} </span>
        </>
      )
      break;
  }
}

export class ProfilesDropdown extends React.Component<NavProfiles> {
  constructor(props: NavProfiles) {
    super(props)
  }

  componentDidMount() {
    if (window && history.pushState) {
      const url = new URL(window.location.href)
      url.searchParams.delete('switchSuccess')
      history.pushState(null, document.title, url.href)
    }
  }

  render () {
    return (
      <>
        <input type="checkbox" className="nav-profiles-dropdown"
          name="nav-menu" id="nav-profiles-dropdown" defaultChecked={false}/>
        <label id="nav-profiles-dropdown-label"
          htmlFor="nav-profiles-dropdown" className="pv-nav-dropl__label">
          {this.props.tooltipType ? 
              <Tooltip startOpen dismissable size={'m'} position={'bottom'} 
                content={getProfilesTooltipContent(this.props)}
                use={this.props.tooltipType == 'INTRO' ? 'info' : 'success'}
                className={`nav-profiles-tooltip nav-profiles-tooltip-${this.props.tooltipType.toLowerCase()}`} >
              </Tooltip>  
            : 
            <></>
          }
          <div style={{ backgroundImage: `url(${this.props.activeProfile.avatarUrl})` }} className="profile-avatar" />
          <div className="label-content">
            <span className="profiles-dropdown-whos-watching">{this.props.strings['DV_PROFILES_WW']}</span>
            <span className="profiles-dropdown-name">
              {this.props.activeProfile ? this.props.activeProfile.name : ''}</span>
          </div>
        </label>    
      </>
    )
  }
}
